import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UploadService } from './upload.service';
import { globals } from '../globals';
import { Contato } from '../models/contato';

@Injectable({
  providedIn: 'root'
})
export class ArquivoContratoService {

  constructor(
    private http: HttpClient,
    private uploadService: UploadService) { }

  public enviarArquivoContrato(formData) {
    return this.uploadService.upload(formData, globals.apiUrl + '/api/ArquivoContrato/SalvarArquivoContrato');
  }

  public baixarArquivoContrato() {
    return this.http.get(globals.apiUrl + '/api/ArquivoContrato/BaixarArquivoContrato', { responseType: 'blob' });
  }

  public gerarContrato(contato: Contato) {
    return this.http.post(globals.apiUrl + '/api/ArquivoContrato/GerarContrato', contato, { responseType: 'blob' });
  }

  public excluirArquivoContrato() {
    return this.http.get(globals.apiUrl + '/api/ArquivoContrato/ExcluirArquivoContrato');
  }

  public existeArquivoContrato() {
    return this.http.get<any>(globals.apiUrl + '/api/ArquivoContrato/ExisteArquivoContrato');
  }

  public consultarVariaveis() {
    return this.http.get<any>(globals.apiUrl + '/api/ArquivoContrato/BuscarVariaveis');
  }

}
